import { render } from "./SupportMembersView.vue?vue&type=template&id=6f3ce287"
import script from "./SupportMembersView.vue?vue&type=script&lang=js"
export * from "./SupportMembersView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__